export const GITHUB_COOKIE_KEY = '__gh';
export const REF_COOKIE_KEY = 'ref';
export const GITHUB_EMULATOR_TOKEN = 'supabaseEmulatorGHToken';
